import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class EmailTemplateService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetDetails(type: number, query: {
        countryId: number,
        langCode: string
    }) {
        return this.baseApiFactory.getData<any>(`/api/EmailTemplate/${type}`, query);
    }

    public Insert(value: {}) {
        return this.baseApiFactory.post('/api/EmailTemplate', value);
    }

    public Update(value: {}) {
        return this.baseApiFactory.put('/api/EmailTemplate', value);
    }

    public Delete(id: number) {
        return this.baseApiFactory.delete('/api/EmailTemplate/' + id);
    }
}

lazyRegister.service('EmailTemplateService', EmailTemplateService);
